import { Navigate, Route, Routes } from "react-router-dom";
import { RoleInfoProvider } from "layouts/role-info/_context/RoleinfoContext";
import Sidebar from "./_components/SideBar";
import Setting from "views/roles/role-info/settings";
import MainPage from "views/roles/role-info/main";
import UsersDataTable from "views/roles/role-info/users";
import InfoLayout from "components/InfoLayout";
import { useTranslation } from "react-i18next";

const RoleInfo = () => {
  const { t } = useTranslation();

  const HEADER_MAP = {
    "/": {
      title: t("roles.roleInfo.title"),
      subtitle: t("roles.roleInfo.subtitle"),
    },
    "/users": {
      title: t("roles.roleInfo.usersTitle"),
      subtitle: t("roles.roleInfo.usersSubtitle"),
    },
    "/settings": {
      title: t("roles.roleInfo.settingsTitle"),
      subtitle: t("roles.roleInfo.settingsSubtitle"),
    },
  };

  const getRoleHeaderKey = (location: Location): string => {
    const path = location.pathname.replace(/\/+$/, "").split("/").pop() || "";
    return path === "" ? "/" : `/${path}`;
  };

  return (
    <InfoLayout
      Provider={RoleInfoProvider}
      Sidebar={Sidebar}
      headerMap={HEADER_MAP}
      getHeaderKey={getRoleHeaderKey}
    >
      <Routes>
        <Route path="/" element={<MainPage />} />
        <Route path="/users" element={<UsersDataTable />} />
        <Route path="/settings" element={<Setting />} />
        <Route path="*" element={<Navigate to={"/dashboard/roles"} />} />
      </Routes>
    </InfoLayout>
  );
};

export default RoleInfo;
